import type { StringsDictionary } from 'lang'
import { clientInfo } from 'configureBrand'

const { displayName } = clientInfo

const strings: StringsDictionary = {
  accountSummary: {},
  login: {
    welcome: 'Bienvenido a',
    accessInfo: `Manage your ${displayName} Commercial and MyLowe's Pro Rewards Credit Card account online from any device anytime, anywhere. Easily and securely access your invoices, statements, pay your bill and more.
    `
  },
  button: {},
  link: {
    manage: 'Manage'
  },
  label: {},
  errors: {}
}

export default strings
